import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FaShieldAlt } from "react-icons/fa";
import { DiJava } from "react-icons/di";
import { SiAmazonaws } from "react-icons/si";

const CERTIFICATES_DATA = [
  {
    title: "eJPT – eLearnSecurity Junior Penetration Tester",
    issuer: "INE",
    icon: <FaShieldAlt className="cert-icon-sec" />,
    color: "#ff3333"
  },
  {
    title: "FullStack Java Developer Certification",
    issuer: "QSpiders",
    icon: <DiJava className="cert-icon-java" />,
    color: "#e67e22"
  },
  {
    title: "AWS Cloud Practitioner Certification",
    issuer: "Coursera / Amazon Web Services",
    icon: <SiAmazonaws className="cert-icon-aws" />,
    color: "#f1c40f"
  }
];

function Certifications() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {CERTIFICATES_DATA.map((cert, idx) => (
        <Col md={4} key={idx} className="mb-4">
          <Card className="project-card-view cert-card">
            <Card.Body className="d-flex flex-column align-items-center text-center">
              <div className="cert-icon-wrapper" style={{ borderColor: cert.color }}>
                {cert.icon}
              </div>
              <Card.Title className="text-light mt-3" style={{ fontSize: "1.15em", fontWeight: "600", minHeight: "55px" }}>
                {cert.title}
              </Card.Title>
              <Card.Subtitle className="purple mt-2" style={{ fontSize: "0.95em" }}>
                Issued by: {cert.issuer}
              </Card.Subtitle>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Certifications;
